import DetailNavTitle from '@/components/business/detail-nav-title';
import theme from '@/style';
import {goBack} from '@/utils';
import React from 'react';
import {useTranslation} from 'react-i18next';
import BetsList from './bets-list';
import BetsTab from './bets-tab';
import {useRoute} from '@react-navigation/native';
import {BasicObject} from '@/types';
import {packageId} from '@/config';
import BetsFilter from './bets-filter';

const MENU = [
  {
    title: 'ALL',
    value: 'ALL',
  },
  {
    title: 'To be drawn',
    value: 'UNKNOWN',
  },
  {
    title: 'Drawn',
    value: 'KNOWN',
  },
  {
    title: 'Won',
    value: 'WON',
  },
];

const Bets = () => {
  const {tag} = (useRoute().params as BasicObject) || {};
  const {i18n} = useTranslation();
  const pageRef = React.useRef<HTMLDivElement>(null);
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [active, setActive] = React.useState(0);
  const [activeTag, setActiveTag] = React.useState(
    packageId === 5 ? tag || 'Color' : tag || 'Kerala',
  );
  const [currentDate, setCurrentDate] = React.useState<Date | undefined>();
  const [headerBox, setHeaderBox] = React.useState({
    height: 0,
    left: 0,
    width: 0,
  });

  const handleGameChange = React.useCallback((nextTag: string) => {
    setActiveTag(nextTag);
    setActive(0);
    setCurrentDate(undefined);
  }, []);

  React.useLayoutEffect(() => {
    const update = () => {
      const pageRect = pageRef.current?.getBoundingClientRect();
      const headerRect = headerRef.current?.getBoundingClientRect();
      setHeaderBox({
        height: headerRect?.height || 0,
        left: pageRect?.left || 0,
        width: pageRect?.width || window.innerWidth,
      });
    };
    update();
    const observer = new ResizeObserver(update);
    pageRef.current && observer.observe(pageRef.current);
    headerRef.current && observer.observe(headerRef.current);
    window.addEventListener('resize', update);
    return () => {
      observer.disconnect();
      window.removeEventListener('resize', update);
    };
  }, []);

  const activeMenu = MENU[active];

  return (
    <div ref={pageRef} style={stylesWeb.page}>
      <div
        ref={headerRef}
        style={{
          ...stylesWeb.header,
          left: headerBox.left,
          width: headerBox.width || '100%',
        }}>
        <DetailNavTitle
          onBack={goBack}
          serverRight
          hideAmount
          title={i18n.t('me.bottom.myBets')}
        />
        <BetsFilter onChange={handleGameChange} value={activeTag} />
        <BetsTab
          currentDate={currentDate}
          onSelectDate={setCurrentDate}
          menu={MENU}
          active={active}
          changeActive={setActive}
        />
      </div>
      <div
        style={{
          ...stylesWeb.content,
          paddingTop: headerBox.height,
        }}>
        <BetsList
          isActive
          game={activeTag}
          status={activeMenu.value}
          currentDate={currentDate}
        />
      </div>
    </div>
  );
};

export default Bets;

const stylesWeb: Record<string, React.CSSProperties> = {
  page: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    backgroundColor: theme.backgroundColor.lightGrey,
  },
  content: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  header: {
    position: 'fixed',
    top: 0,
    zIndex: 10,
    backgroundColor: '#fff',
    flexShrink: 0,
  },
};
